import { render, staticRenderFns } from "./LabLabel.vue?vue&type=template&id=4923200d&"
import script from "./LabLabel.vue?vue&type=script&lang=js&"
export * from "./LabLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports